import type { FlowId } from '@/flows/types';
import { accessGroupCreationRuntime } from './accessGroupCreation.runtime';
import { bulkUserImportRuntime } from './bulkUserImport.runtime';
import { deviceSetupRuntime } from './deviceSetup.runtime';
import { userCreationRuntime } from './userCreation.runtime';

const RUNTIME_REGISTRY = {
  'device-setup': deviceSetupRuntime,
  'user-creation': userCreationRuntime,
  'access-group-creation': accessGroupCreationRuntime,
  'bulk-user-import': bulkUserImportRuntime,
} as const;

export function getFlowRuntime(flowId: FlowId) {
  return RUNTIME_REGISTRY[flowId];
}

